import React, { PureComponent, ReactElement, ReactNode } from 'react'
import { Modal } from 'antd'
import { Translate } from 'react-localize-redux'
import {checkIsNumberHash, getterHash, goBack} from 'core/utils/helpers'
import { IStateFormStepper, PropsFormStepper } from './form-stepper.interfaces'
import { FormMode } from '../../interfaces'
import history from 'core/history/history'
import styles from './FormStepper.module.scss'

export default class FormStepper<P extends PropsFormStepper> extends PureComponent<P, IStateFormStepper> {
  state = {
    step: getterHash(this.props.location),
    lastPage: 5,
    showConfirmModal: false
  }

  public componentDidMount (): void {
    if (this.props.mode === FormMode.create && this.state.step !== 1) {
      history.push({
        pathname: this.props.location.pathname,
        hash: '1'
      })
    }
  }

  public componentDidUpdate (prevProps: Readonly<P>, prevState: Readonly<IStateFormStepper>): void {
    if (getterHash(prevProps.location) !== getterHash(this.props.location)) {
      this.setState(() => { return { step: checkIsNumberHash(getterHash(this.props.location)) } })
    }
  }

  public render (): ReactElement {
    return (
      <div className={styles.container}>
        <div className={styles.formWrap} style={{ marginBottom: this.getFormSteps() ? '70px' : '0' }}>
          <p className={styles.formSubTitle} id='form-sub-title'>{this.getSubTitleForm()}</p>
          {this.getCurrentForm()}
          <Modal
            title={this.getModelTitle() || <Translate id='businessUnits.wizardCreateBtn' />}
            visible={this.state.showConfirmModal}
            onOk={this.confirm}
            onCancel={this.hideModal}
            okText={<span><Translate id='common.form.buttons.confirmCancelBtn' /></span>}
            cancelText={<Translate id='common.form.buttons.closeAlertBtn' />}
            okButtonProps={{ className: 'submit-btn', type: 'default' }}
            cancelButtonProps={{ className: 'default-btn' }}
          >
            <p>
              <Translate id='common.cancelModalText' />
            </p>
          </Modal>
        </div>
        <div className={styles.stepsWrap}>{this.getFormSteps()}</div>
      </div>
    )
  }
  protected confirm (): void {}
  protected hideModal (): void {}
  protected goBack = goBack
  protected getTitleForm (): ReactNode {
    return ''
  }
  protected getSubTitleForm (): ReactNode {
    return ''
  }
  protected getCurrentForm (): ReactNode {
    return null
  }
  protected getFormSteps (): ReactNode {
    return null
  }
  protected getModelTitle (): ReactNode {
    return null
  }
}
